import React, { Fragment, useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import forge from "node-forge";
import Address from "./Address";
import CardPayment from "./CardPayment";
import ActionMenu from "../layout/ActionMenu";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import SubscribeContext from "../../context/subscribe/SubscribeContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import useForm from "../../hooks/useForm";
import Preloader from "./../layout/Preloader";
import "./BillingOrder.css";
import { getStateCode } from "../../utils/Lookup";
import useEntityContext from "../../hooks/entity-context";
import { ADD_SUBSCRIPTION, UPDATE_PAYMENT } from "../../context/types";
import useTokenCheck from "../../hooks/useTokenCheck";
import ConfigContext from "../../context/config/ConfigContext";
import usePageTitle from "../../hooks/usePageTitle";
import { env } from "../../env";

const Billing = (props) => {
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts } = alertContext;
  const { user } = authContext;
  const subscribeContext = useContext(SubscribeContext);
  const { subscribeRequest } = subscribeContext;
  const navigationContext = useContext(NavigationContext);
  const { fieldRefs } = navigationContext;
  const configContext = useContext(ConfigContext);

  const { getConfigValueByCode } = configContext;

  const location = useLocation();
  const history = useHistory();
  const [loading, updateEntity] = useEntityContext();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Billing",
  });

  const getCardType = (cardNumber) => {
    let card = cardNumber.toString();
    // const checkCard = isCardFromProps(cardNumber);
    if (
      location?.state?.cardDetails?.cardType &&
      cardNumber.substr(-4) === location.state.cardDetails.cardNumber.substr(-4)
    ) {
      const cardType = location.state.cardDetails.cardType;
      if (cardType === 1) {
        return "visa";
      } else if (cardType === 2) {
        return "master";
      } else if (cardType === 3) {
        return "amex";
      } else if (cardType === 4) {
        return "discover";
      }
    } else {
      if (card.startsWith("34") || card.startsWith("37")) {
        return "amex";
      } else if (card.startsWith("4")) {
        return "visa";
      } else if (
        card.startsWith("51") ||
        card.startsWith("52") ||
        card.startsWith("53") ||
        card.startsWith("54") ||
        card.startsWith("55") ||
        card.startsWith("22") ||
        card.startsWith("23") ||
        card.startsWith("24") ||
        card.startsWith("25") ||
        card.startsWith("26") ||
        card.startsWith("27")
      ) {
        return "master";
      } else if (card.startsWith("6")) {
        return "discover";
      } else {
        return "invalid";
      }
    }
  };

  const getCardTypeCode = (cardNumber) => {
    let card = getCardType(cardNumber);
    if (card === "visa") {
      return 1;
    } else if (card === "master") {
      return 2;
    } else if (card === "amex") {
      return 3;
    } else if (card === "discover") {
      return 4;
    } else {
      return -1;
    }
  };

  const [address, setAddress] = useState({
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipcode: "",
    phonenumber: "",
  });
  // let  {address1, address2, city, state, zipcode, phone1, phone2, phone3 } =  address;
  const [addressFieldRefs, setAddressFieldRefs] = useState(null);

  const addressChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const phoneNoChange = (value, floatValue) => {
    console.log("Formatted Value", value);
    console.log("UnFormatted Value", floatValue);
    setAddress({ ...address, phonenumber: value });
    setUnformattedAddressValues({
      ...unformattedAddressValues,
      phonenumber: floatValue?.toString(),
    });
  };

  const {
    Popup: PopupAddress,
    validateField: validateAddressField,
    validateAllFields: validateAllAddressFields,
    isFormValid: isAddressFormValid,
    setIsFormValid: setIsAddressFormValid,
    setValidationControl: setAddressValidationControl,
    unformattedValues: unformattedAddressValues,
    setUnformattedValues: setUnformattedAddressValues,
  } = useForm({
    inputList: addressFieldRefs,
    unformattedAddressValues: {
      phoneNumber: "",
    },
    screenName: "subscription_address",
  });

  useEffect(() => {
    const isValid = validateAllAddressFields();
    setIsAddressFormValid(isValid);
    console.log("Address Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  // const [isCardFromProps, setIsCardProps] = useState(false);

  const [payment, setPayment] = useState({
    cardholdername: "",
    firstName: "",
    lastName: "",
    cardNumber: "",
    month: "",
    year: "",
    cvvCode: "",
  });
  const [paymentFieldRefs, setPaymentFieldRefs] = useState(null);

  const checkFieldRange = (value, fieldName) => {
    //get allowed ranges for the given field
    console.log("Custom Field", fieldName);
    const checkCard = isCardFromProps(value);
    console.log("Custom value", value, checkCard);
    if (checkCard) {
      return "";
    } else {
      var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
      var mastercardRegEx =
        /^5[1-5][0-9]{14}|^(222[1-9]|22[3-9]\\d|2[3-6]\\d{2}|27[0-1]\\d|2720)[0-9]{12}$/;
      var amexpRegEx = /^(?:3([7]|[4])[0-9](\d{12}|\d{14}))$/;
      var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
      let res;
      if (
        visaRegEx.test(value) ||
        mastercardRegEx.test(value) ||
        amexpRegEx.test(value) ||
        discovRegEx.test(value)
      ) {
        res = "";
      } else {
        res = getConfigValueByCode("generalConfig", "RESPONSE_MSG", 415);
      }
      console.log("Custom Field res", res);
      return res;
    }
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
    setValidationControl,
    unformattedValues,
    setUnformattedValues,
  } = useForm({
    inputList: paymentFieldRefs,
    screenName: "subscription_payment",
    unformattedValuesList: {
      cardNumber: "",
    },
    customRules: {
      cardNumber: checkFieldRange,
    },
    excludePrefix: {
      cardNumber: true,
    },
  });

  const isCardFromProps = (value) => {
    const currentCard = value;
    console.log("------>isCardFromProps", location);
    if (location?.state?.cardDetails?.cardNumber) {
      console.log(
        "------>isCardFromProps",
        currentCard?.substr(-4),
        location.state.cardDetails.cardNumber.substr(-4),
        currentCard.substr(-4) ===
          location.state.cardDetails.cardNumber.substr(-4),
        currentCard.charAt(0),
        currentCard.charAt(0) === "1",
        currentCard.length
      );
      if (
        currentCard.substr(-4) ===
          location.state.cardDetails.cardNumber.substr(-4) &&
        currentCard.charAt(0) === "1" &&
        currentCard.length > 10
      ) {
        return true;
        // setIsCardProps(true);
      } else {
        return false;
        // setIsCardProps(false);
      }
    }
  };

  useEffect(() => {
    console.log("Custom Payment Form is valid", payment);
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Custom Payment Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payment]);
  // useEffect(() => {
  //   if (subscribeRequest && subscribeRequest.action==='update-payment') {
  //     console.log("Search Completed::::", subscribeCards);
  //   }
  //   //eslint-disable-next-line
  // }, [subscribeRequest]);
  // let {cardholdername, cardNumber, month, year, cvvCode } = payment;
  const paymentChange = (e) => {
    setPayment({ ...payment, [e.target.name]: e.target.value });
  };

  const cardNoChange = (value) => {
    console.log("cardNoChange", value);
    setUnformattedValues({
      ...unformattedValues,
      cardNumber: value?.toString(),
    });
    setPayment({ ...payment, cardNumber: value });
  };

  console.log("unformattedValues", unformattedValues);

  const setOriginalValue = (value) => {
    setUnformattedValues({
      ...unformattedValues,
      cardNumber: value,
    });
  };
  const prevCard = () => {
    return payment.cardNumber;
  };
  useEffect(() => {
    console.log("field refs", fieldRefs);
    if (fieldRefs && fieldRefs["payment"]) {
      console.log("Assiging payment refs", fieldRefs["payment"]);
      setPaymentFieldRefs(fieldRefs["payment"]);
      setValidationControl(fieldRefs["payment"]);
    }
    if (fieldRefs && fieldRefs["address"]) {
      console.log(
        "Assiging subscription_address password refs",
        fieldRefs["address"]
      );
      setAddressFieldRefs(fieldRefs["address"]);
      setAddressValidationControl(fieldRefs["address"]);
    }
    //eslint-disable-next-line
  }, [fieldRefs]);
  const { hasTokenExpired } = useTokenCheck();
  const displayCart = async () => {
    await hasTokenExpired();
    console.log("@@@SubRequest", subscribeRequest);
    clearAlerts();
    const cardType = getCardTypeCode(payment.cardNumber);
    const {
      subscribeRequest: {
        contractid,
        thresholdAmount,
        maxRecharges,
        rechargevalue,
        cardSerialNumber,
        function: subscribeFunction,
      },
    } = subscribeRequest;
    const [firstName, lastName] = payment.cardholdername.split(" ");
    const { cardNumber, year, month, cvvCode } = payment;
    const {
      address1,
      address2,
      city,
      state: stateCode,
      zipcode,
      phonenumber,
    } = address;
    const state =
      stateCode && stateCode.length === 2 ? stateCode : getStateCode(stateCode);
    // console.log("@@@DES SubRequest", subscribeRequest);
    const payload = {
      cardSerialNumber,
      contractid,
      thresholdAmount,
      maxRecharges,
      rechargevalue,
      firstName,
      lastName,
      cardNumber,
      year,
      month,
      cvvCode,
      cardType,
      address1,
      address2,
      city,
      state,
      zipcode,
      phonenumber,
    };
    console.log("@@@placeOrder", payload);
    console.log("PUB Key base64 encoded: ", env.REACT_APP_HMW_PUB_KEY);
    const pubKeyE64 = env.REACT_APP_HMW_PUB_KEY;
    if (!pubKeyE64) {
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 464);
      setAlert(msg, "danger");
      return;
    }
    const pubKeyBuf = Buffer.from(pubKeyE64, "base64");
    const pubkey = pubKeyBuf.toString();
    // console.log("@@@Pubkey", pubkey);
    //encrypt CC with RSA public key
    // var rsaEncrypt = new JSEncrypt();
    // rsaEncrypt.setPublicKey(pubkey);
    // rsaEncrypt.setPublicKey(pubKeyE64);
    // var rsaEncryptedCardNumber = rsaEncrypt.encrypt(cardNumber);
    const pubKeyVar = forge.pki.publicKeyFromPem(pubkey);
    // const encBytes = "41111111111111";

    const encrypted = pubKeyVar.encrypt(payment.cardNumber, null, {
      md: forge.md.sha256.create(),
    });
    payload.cardNumber = btoa(encrypted);
    // payload.cardNumber = rsaEncryptedCardNumber;
    console.log("RSA encrypted Card Number [base64]: ", payload.cardNumber);
    console.log("RSA encrypted Payload: ", payload);
    console.log("subscribeRequest.function: ", subscribeFunction);
    let resStatus = null;
    if (subscribeFunction === "get_spa") {
      resStatus = await updateEntity(payload, UPDATE_PAYMENT);
    } else {
      resStatus = await updateEntity(payload, ADD_SUBSCRIPTION);
    }
    console.log("Res Status: ", resStatus);
    if (resStatus) {
      history.push("/user-cart");
    }
  };

  useEffect(() => {
    if (user) {
      console.log("User::::", user, location);
      const cardholdername = user.firstName + " " + user.lastName;
      const firstName = user.firstName;
      const lastName = user.lastName;
      let cardNumber;
      if (location?.state?.cardDetails) {
        console.log("PROPs", location.state.cardDetails);
        const cardType = getCardType(location.state.cardDetails.cardNumber);
        const cardLength = cardType === "amex" ? 11 : 12;
        console.log("cardNumber-->", cardType, cardLength);
        const card =
          "1".repeat(cardLength) + location.state.cardDetails.cardNumber;
        setUnformattedValues({
          ...unformattedValues,
          cardNumber: card,
        });
        cardNumber =
          "#".repeat(cardLength) + location.state.cardDetails.cardNumber;
      }
      setPayment({
        ...payment,
        cardholdername,
        firstName,
        lastName,
        cardNumber,
      });
      const fulladdress = user.address.split(", ");
      const address1 = fulladdress[0];
      const address2 = fulladdress[1];
      const city = user.town;
      const state =
        user.state.length === 2 ? user.state : getStateCode(user.state);
      const zipcode = user.zipcode;
      const phonenumber = user.phoneNumber;
      setAddress({
        ...address,
        address1,
        address2,
        city,
        state,
        zipcode,
        phonenumber,
      });
    }
    //eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <PopupAddress />
      <Popup />
      {loading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronHome billing"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="privateView__pageTitle">
          <h1> SUBSCRIPTION PAYMENT </h1>
          {/* <div className="privateView__pageTitle__note">
            <span className="required">*</span>
            denotes a required field
          </div> */}
        </div>
        <div className="billing__cardList">
          <div className="billing__cardList__cardSection">
            {/* <CardPayment payment={payment} paymentChange={paymentChange}/> */}
            <CardPayment
              paymentChange={paymentChange}
              cardNoChange={cardNoChange}
              payment={payment}
              getCardType={getCardType}
              title="Enter Credit Card Information"
              onBlur={validateField}
              preserveCardNumber={setOriginalValue}
              prevCard={prevCard}
            />
          </div>
          <div className="billing__cardList__addressSection">
            {/* <Address address={address} addressChange={addressChange}/> */}
            <Address
              addressChange={addressChange}
              phoneNoChange={phoneNoChange}
              address={address}
              title="Enter Billing Address"
              onBlur={validateAddressField}
            />
          </div>
        </div>
        <div className="billing__actions">
          <input
            type="submit"
            name="btnProceedToCart"
            className="btn btn-primary billing__actions__action"
            onClick={displayCart}
            disabled={!isAddressFormValid || !isFormValid}
            value="Proceed to Cart"
            aria-label="Proceed to Cart"
          />
        </div>
      </div>
    </Fragment>
  );
};

export default Billing;
